module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/balcony/bricks.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/balcony/bricks.jpg
// module id = 513
// module chunks = 0